module.exports = __webpack_public_path__ + "static/media/img-01.b4827702.jpg";